export const customerFields = [
    {
        name: "custId",
        label: 'Customer ID',
        type: "text",
        required: true,
        readonly: true
    },
    {
        name: "custName",
        label: 'Name',
        type: "text",
        required: true,
    },
    {
        name: "phone",
        label: 'Phone',
        type: "text",
        required: true,
    },
    {
        name: "email",
        label: 'Email',
        type: "text",
    },

    {
        name: "channel",
        label: 'Channel',
        type: "select",

    },

    {
        name: "address1",
        label: 'Address 1',
        type: "text",
        required: true
    },

    {
        name: "address2",
        label: 'Address 2',
        type: "text",

    },

    {
        name: "city",
        label: 'City',
        type: "text",
        required: true
    },

    {
        name: "state",
        label: 'State',
        type: "text",
        required: true

    },
    {
        name: "country",
        label: 'Country',
        type: "select",
        required: true
    },

    {
        name: "pinCode",
        label: 'PinCode',
        type: "text",
        required: true
    },


    {
        name: "createdBy",
        label: 'Created By',
        type: "text",
        readonly: true
    },

    {
        name: "updatedBy",
        label: 'Updated By',
        type: "text",
        readonly: true
    },

    {
        name: "updatedDate",
        label: 'Updated Date',
        type: "text",
        readonly: true
    },


]